export default "__VITE_ASSET__CxCTplgu__"